import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import UserCampaignHistoryItem from "../user-campaigns-history-item/component"
import {langRegister} from "../../services/langRegister";
import {marketRegister} from "../../services/marketRegister";
import ModalPassword from "../modal-password/component";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {demoRegister} from "../../services/demoRegister";
import LanguageButton from "../language-button/component";
import ErrorHandler from "../error-handler/component";
import queryString from "query-string";

class UserInsights extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            data: {}
        };
    };

    componentWillMount() {
        this._updateData();
    }

    _updateData(){
        dataRegister.getInsights(marketRegister.code()).then((response) => {
            this.setState({isLoading: false, data: response});
        }, (error) => {
            this.setState({isLoading: false, error: true});
        });
    }

    _signOut(){
        userRegister.remove();
        tokenRegister.remove();
        this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/login");
    }

    _renderRenew(){
        if(this.state.data.renew > 0){
            return Math.round((this.state.data.renew / this.state.data.active) * 100);
        }else{
            return 0
        }
    }

    _renderLockin(){
        if(this.state.data.lock_in > 0){
            return Math.round((this.state.data.lock_in / this.state.data.active) * 100);
        }else{
            return 0
        }
    }

    _renderGauge(){
        let steps = {
            "1": {
                min: 1,
                max: 25
            },
            "2": {
                min: 25,
                max: 50
            },
            "3": {
                min: 50,
                max: 75
            },
            "4": {
                min: 75,
                max: 100
            },
            "5": {
                min: 100,
                max: 125
            },
            "6": {
                min: 125,
                max: 150
            },
            "7": {
                min: 150,
                max: 175
            },
            "8": {
                min: 175,
                max: 200
            }
        };
        if(this.state.data.average_performance > 200){
            return (
                <img className={Styles.containerInnerItemInnerMeterBackgroundContainerLine} src={require("../../assets/images/meter/ab_gauge_8.png")}/>
            )
        }else{
            for(var key in steps){
                if(steps[key].min < this.state.data.average_performance && steps[key].max > this.state.data.average_performance){
                    return(
                        <img className={Styles.containerInnerItemInnerMeterBackgroundContainerLine} src={require("../../assets/images/meter/ab_gauge_"+key+".png")}/>
                    )
                }
            }
        }
    }

    _renderText(item) {
        return langRegister.get("user-insights", item);
    }

    render() {
        return (
            <div>
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>

                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_1")}
                    </div>
                </div>
                <div className={Styles.container}>
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div className={Styles.containerInner}>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_2")}<br/>
                                        {this._renderText("item_3")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValue, Styles.containerInnerItemInnerValueGreen)}>
                                        {this.state.data.active}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={cx(Styles.containerInnerItemInnerTitle, Styles.containerInnerItemInnerTitleMeter)}>
                                        {this._renderText("item_4")}<br/>
                                        {this._renderText("item_5")}
                                    </div>
                                    <div className={Styles.containerInnerItemInnerMeterBackgroundContainer}>
                                        <img className={Styles.containerInnerItemInnerMeterBackgroundContainerBg} src={require("../../assets/images/meter/ab_gauge_bg.png")}/>
                                        {
                                            this._renderGauge()
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_6")}<br/>
                                        {this._renderText("item_7")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValue, Styles.containerInnerItemInnerValueRed)}>
                                        {this.state.data.awaiting_payment}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_new.svg")}/>
                                        {this._renderText("item_8")}<br/>
                                        {this._renderText("item_9")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValue, Styles.containerInnerItemInnerValueGreenFade)}>
                                        {this._renderRenew()}<span className={Styles.containerInnerItemInnerValuePercent}>%</span>
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        <img className={Styles.containerInnerItemInnerTitleLock} src={require("../../assets/images/AB_lock_green_new.svg")}/>
                                        {this._renderText("item_10")}<br/>
                                        {this._renderText("item_11")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValue, Styles.containerInnerItemInnerValueGreenFade)}>
                                        {this._renderLockin()}<span className={Styles.containerInnerItemInnerValuePercent}>%</span>
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_12")}<br/>
                                        {this._renderText("item_13")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValue, Styles.containerInnerItemInnerValueGrey)}>
                                        {this.state.data.ended}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.loader}>
                            <ErrorHandler/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default UserInsights;


// WEBPACK FOOTER //
// ./src/components/user-insights/component.js